import { render, staticRenderFns } from "./CreateFaq.vue?vue&type=template&id=bbf2e53c&scoped=true"
import script from "./CreateFaq.vue?vue&type=script&lang=ts"
export * from "./CreateFaq.vue?vue&type=script&lang=ts"
import style0 from "./CreateFaq.vue?vue&type=style&index=0&id=bbf2e53c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf2e53c",
  null
  
)

export default component.exports